import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@services/user.service';
import { ToastService } from '@utils/toast.service';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { PasswordModule } from 'primeng/password';
import { ConfirmDialogService } from '@utils/confirm-dialog.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuItem, SelectItemGroup } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { CatalogService } from '@services/catalog.service';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { SpeedDialModule } from 'primeng/speeddial';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectModule } from 'primeng/select';
import { PlaceholderCard } from '@components/placeholders/card/card.component';
import { PlaceholderTable } from '@components/placeholders/table/table.component';
import { MenuModule } from 'primeng/menu';
import { DividerModule } from 'primeng/divider';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { AccordionModule } from 'primeng/accordion';
import { FieldsetModule } from 'primeng/fieldset';
import { TabViewModule } from 'primeng/tabview';

@Component({
  selector: 'app-user-update',
  imports: [
    CommonModule,
    FormsModule,
    BackboneComponent,
    BreadcrumbComponent,
    ReactiveFormsModule,
    InputTextModule,
    InputMaskModule,
    PasswordModule,
    ButtonModule,
    MultiSelectModule,
    InputNumberModule,
    TableModule,
    TagModule,
    SpeedDialModule,
    NgbDropdownModule,
    SelectModule,
    PlaceholderCard,
    PlaceholderTable,
    MenuModule,
    DividerModule,
    InputGroupModule,
    InputGroupAddonModule,
    AccordionModule,
    FieldsetModule,
    TabViewModule,
  ],
  templateUrl: './update.component.html',
  styleUrl: './update.component.scss',
})
export class UserUpdatePage {
  private formBuilder = inject(FormBuilder);
  private activatedRoute = inject(ActivatedRoute);
  private userService = inject(UserService);
  private router = inject(Router);
  private toastService = inject(ToastService);
  private confirmDialogService = inject(ConfirmDialogService);
  private titleService = inject(Title);
  private catalogService = inject(CatalogService);

  public isLoadingUser = false;
  public isLoadingSessions = false;
  public isSaving = false;
  public isDeleting = false;
  public Object = Object;

  public userActionsMenu: MenuItem[] = [];
  public username!: string;
  public user: any = null;
  public roles: any = [];
  public permissions!: SelectItemGroup[];
  public shareLimit: any = [];
  public status = [
    { label: 'Activo', value: 'ACTIVE' },
    { label: 'Inactivo', value: 'INACTIVE' },
  ];
  public sessions: any = [];

  public formUser = this.formBuilder.group({
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    nickname: [null, Validators.required],
    email: [null, [Validators.required, Validators.email]],
    password: [null, [Validators.minLength(8)]],
    rpassword: [null, [Validators.minLength(8)]],
    role: [null, Validators.required],
    permissions: [null],
    numberSessions: [null],
    prices: this.formBuilder.group({
      REGISTRO_CIVIL: this.formBuilder.group({
        DIGITALIZACION: [1, Validators.required],
        CORRECCION_ACTA: [1, Validators.required],
        MARCO_FOLIO_REVERSO: [1, Validators.required],
        BUSCAR_ACTO: this.formBuilder.group({
          AGUASCALIENTES: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          BAJA_CALIFORNIA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          BAJA_CALIFORNIA_SUR: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CAMPECHE: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          COAHUILA_DE_ZARAGOZA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          COLIMA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CHIAPAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CHIHUAHUA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CIUDAD_DE_MEXICO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          DURANGO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          GUANAJUATO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          GUERRERO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          HIDALGO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          JALISCO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MEXICO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MICHOACAN_DE_OCAMPO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MORELOS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          NAYARIT: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          NUEVO_LEON: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          OAXACA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          PUEBLA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          QUERETARO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          QUINTANA_ROO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SAN_LUIS_POTOSI: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SINALOA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SONORA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TABASCO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TAMAULIPAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TLAXCALA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          VERACRUZ: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          YUCATAN: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          ZACATECAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
        }),
      }),
      SAT: this.formBuilder.group({
        CAMBIO_EMISION: [1, Validators.required],
        CEDULA_IDENTIFICACION_FISCAL: [1, Validators.required],
        CITA_PERSONA_FISICA: [1, Validators.required],
        CONSTANCIA_SITUACION_FISCAL: [1, Validators.required],
        OPINION_CUMPLIMIENTO: [1, Validators.required],
        RECUPERACION_CFDI: [1, Validators.required],
        RECUPERACION_DECLARACION: [1, Validators.required],
        CITA_PERSONA_MORAL: [1, Validators.required],
        ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA: [1, Validators.required],
        ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA: [1, Validators.required],
        CONTRASENA_CIEC_INE: [1, Validators.required],
      }),
      IMSS: this.formBuilder.group({
        INFORMACION_NSS: [1, Validators.required],
        CONSULTAR_NSS: [1, Validators.required],
        ASIGNAR_CORREO_NSS: [1, Validators.required],
        SEMANAS_COTIZADAS: [1, Validators.required],
        VIGENCIA_DERECHO: [1, Validators.required],
        NO_DERECHOHABIENTE: [1, Validators.required],
      }),
      RENAPO: this.formBuilder.group({
        CURP: [1, Validators.required],
        CORRECCION_CURP: [1, Validators.required],
        UNIFICACION_CURP: [1, Validators.required],
        CERTIFICACION_CURP: [1, Validators.required],
      }),
      ISSSTE: this.formBuilder.group({
        TALON_PAGOS: [1, Validators.required],
        CONSTANCIA_ACREDITACION_NO_AFILIACION: [1, Validators.required],
      }),
      CFE: this.formBuilder.group({
        RECIBO_DE_LUZ: [1, Validators.required],
      }),
    }),
    numberSharesAllowed: this.formBuilder.group({
      REGISTRO_CIVIL_MARCOS_FOLIOS_REVERSOS: [null, Validators.required],
      REGISTRO_CIVIL_BUSCAR_ACTO: [null, Validators.required],
      REGISTRO_CIVIL_DIGITALIZATION: [null, Validators.required],
      REGISTRO_CIVIL_CORRECCION_ACTA: [null, Validators.required],

      SAT_CAMBIO_EMISION: [null, Validators.required],
      SAT_CONSTANCIA_SITUACION_FISCAL: [null, Validators.required],
      SAT_OPINION_CUMPLIMIENTO: [null, Validators.required],
      SAT_CEDULA_IDENTIFICACION_FISCAL: [null, Validators.required],
      SAT_RECUPERACION_CFDI: [null, Validators.required],
      SAT_RECUPERACION_DECLARACION: [null, Validators.required],
      SAT_CITA_PERSONA_FISICA: [null, Validators.required],
      SAT_CITA_PERSONA_MORAL: [null, Validators.required],
      SAT_ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA: [null, Validators.required],
      SAT_ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA: [null, Validators.required],
      SAT_CONTRASENA_CIEC_INE: [null, Validators.required],
      SAT_RESTABLECER_CONTRASENA: [null, Validators.required],

      IMSS_INFORMACION_NSS: [null, Validators.required],
      IMSS_CONSULTAR_NSS: [null, Validators.required],
      IMSS_ASIGNAR_CORREO_NSS: [null, Validators.required],
      IMSS_SEMANAS_COTIZADAS: [null, Validators.required],
      IMSS_VIGENCIA_DERECHO: [null, Validators.required],
      IMSS_NO_DERECHOHABIENTE: [null, Validators.required],

      RENAPO_CURP: [null, Validators.required],
      RENAPO_CORRECCION_CURP: [null, Validators.required],
      RENAPO_UNIFICACION_CURP: [null, Validators.required],
      RENAPO_CERTIFICACION_CURP: [null, Validators.required],

      ISSSTE_TALON_PAGOS: [null, Validators.required],
      ISSSTE_CONSTANCIA_ACREDITACION_AFILIACION: [null, Validators.required],

      CFE_RECIBO_DE_LUZ: [null, Validators.required],
    }),
  });

  ngOnInit() {
    this.userService.roles().then((response: any) => (this.roles = response));

    this.catalogService.getPermissionsList().then((response) => {
      this.permissions = response;
    });

    this.loadingUser();
  }

  loadingUser = async () => {
    this.isLoadingUser = true;
    this.isLoadingSessions = true;

    this.activatedRoute.params.subscribe(async (routeParams) => {
      this.username = routeParams['slug'];

      this.titleService.setTitle('Viendo usuario: ' + this.username + ' ' + this.titleService.getTitle());

      await this.userService.getByUsername(this.username).then((response: any) => {
        if (response.content.length <= 0) {
          this.router.navigate(['/user']);
          this.toastService.error('Usuario no encontrado.');
        }

        this.user = response.content;
      });

      this.formUser.get('firstName')?.setValue(this.user.firstName);
      this.formUser.get('lastName')?.setValue(this.user.lastName);
      this.formUser.get('nickname')?.setValue(this.user.nickname);
      this.formUser.get('email')?.setValue(this.user.email);
      this.formUser.get('role')?.setValue(this.user.roleId);
      this.formUser.get('permissions')?.setValue(this.user.permissions);
      this.formUser.get('numberSessions')?.setValue(this.user.numberSessions);
      this.formUser.get('prices')?.setValue(this.user.prices);
      this.formUser.get('numberSharesAllowed')?.setValue(this.user.numberSharesAllowed);

      this.userService.obtainShareLimit(this.user.userId).then((response: any) => (this.shareLimit = response));

      this.userActionsMenu = [];

      if (this.user.status === 'ACTIVE') {
        this.userActionsMenu.push({
          label: 'Desactivar usuario',
          icon: 'pi pi-times-circle',
          command: (event: any) => this.changeStatus(event, 'INACTIVE'),
        });
      }

      if (this.user.status === 'INACTIVE') {
        this.userActionsMenu.push({
          label: 'Activar usuario',
          icon: 'pi pi-check-circle',
          command: (event: any) => this.changeStatus(event, 'ACTIVE'),
        });
      }

      this.userActionsMenu.push({
        label: 'Eliminar usuario',
        icon: 'pi pi-trash',
        command: (event: any) => this.delete(event),
      });

      this.isLoadingUser = false;

      await this.userService.getSessionsList(this.user.userId).then((response: any) => (this.sessions = response));

      this.isLoadingSessions = false;
    });
  };

  save = async () => {
    this.isSaving = true;

    await this.userService
      .save(this.username, this.formUser.value)
      .then((response) => this.toastService.success('Usuario actualizado con éxito.'))
      .catch((error: any) => this.toastService.error(error.error.data.message));

    this.isSaving = false;
  };

  delete = (event: Event) => {
    this.isDeleting = true;

    this.confirmDialogService
      .dialog(event, 'Al eliminar este colaborador, se inactivaran los demás colaboradores de su red.', 'Continuar', 'Cancelar')
      .then(() => {
        this.userService
          .delete(this.username)
          .then(() => {
            this.toastService.success('Usuario eliminado con éxito.');
            this.router.navigate(['/user']);
          })
          .catch((error: any) => {
            this.toastService.error(error.error.data.message);
            this.isDeleting = false;
          });
      })
      .catch(() => (this.isDeleting = false));
  };

  changeStatus = (event: Event, status: string) => {
    this.isSaving = true;
    let msg;

    if (status == 'ACTIVE') {
      msg = '¿Está seguro de activar este usuario?';
    } else {
      msg = 'Al desactivar este colaborador, se inactivaran los demás colaboradores de su red.';
    }

    this.confirmDialogService
      .dialog(event, msg, 'Continuar', 'Cancelar')
      .then(() => {
        this.userService
          .changeStatus(this.user.userId, status)
          .then(async () => {
            this.toastService.success('Usuario actualizado con éxito.');
            await this.loadingUser();
            this.isSaving = false;
          })
          .catch((error: any) => {
            this.isSaving = false;
          });
      })
      .catch(() => (this.isSaving = false));
  };

  logout = (item: any) => {
    this.userService
      .closeSession({
        id: item.userSessionId,
      })
      .then(() => this.toastService.success('Sesión cerrada con éxito.'));
  };

  formatEstadoName(estado: string): string {
    const estadosMap: { [key: string]: string } = {
      AGUASCALIENTES: 'Aguascalientes',
      BAJA_CALIFORNIA: 'Baja California',
      BAJA_CALIFORNIA_SUR: 'Baja California Sur',
      CAMPECHE: 'Campeche',
      COAHUILA_DE_ZARAGOZA: 'Coahuila',
      COLIMA: 'Colima',
      CHIAPAS: 'Chiapas',
      CHIHUAHUA: 'Chihuahua',
      CIUDAD_DE_MEXICO: 'Ciudad de México',
      DURANGO: 'Durango',
      GUANAJUATO: 'Guanajuato',
      GUERRERO: 'Guerrero',
      HIDALGO: 'Hidalgo',
      JALISCO: 'Jalisco',
      MEXICO: 'México',
      MICHOACAN_DE_OCAMPO: 'Michoacán',
      MORELOS: 'Morelos',
      NAYARIT: 'Nayarit',
      NUEVO_LEON: 'Nuevo León',
      OAXACA: 'Oaxaca',
      PUEBLA: 'Puebla',
      QUERETARO: 'Querétaro',
      QUINTANA_ROO: 'Quintana Roo',
      SAN_LUIS_POTOSI: 'San Luis Potosí',
      SINALOA: 'Sinaloa',
      SONORA: 'Sonora',
      TABASCO: 'Tabasco',
      TAMAULIPAS: 'Tamaulipas',
      TLAXCALA: 'Tlaxcala',
      VERACRUZ: 'Veracruz',
      YUCATAN: 'Yucatán',
      ZACATECAS: 'Zacatecas',
    };

    return estadosMap[estado] || estado;
  }
}
